/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import Reflux from 'reflux';
import {
    hashHistory,
    withRouter,
} from 'react-router';
import {
    Modal,
    Button,
    message,
    Upload,
    Icon,
} from 'antd';
import {
    DmsTab,
    TableView,
    FilterBox,
} from 'Components';
import {
    specActions,
    specStore,
} from './store';
import {
    specList,
    productAync,
    specDelete,
} from '../../service/productSpec';
import {openNotice, toImportExcel, config} from 'Utils';
import {treeList2} from "../../service/org";

const confirm = Modal.confirm;

class ProductSpecList extends Reflux.Component {
    constructor(props) {
        super(props);
        this.store = Reflux.initStore(specStore);
        this.state = {
            opts: ['产品规格'],
            key: 0,
            filterBoxVisible: false,
            rows: [],
            total: 0,
            selectedKeys: [],
            searchObj: {
                propertyName: '', // 规格
                categoryId: '', // 分类id
                propertyCategoryCode: '', // 本体/附件
                activeFlag: '', // 是否有效（1-有效；0-无效）
                p: 1,
                s: 10,
            },
            tree: [],
        };
        this.pageChange = this.pageChange.bind(this);
        this.visibleChange = this.visibleChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.operationHandle = this.operationHandle.bind(this);
        this.goView = this.goView.bind(this);
        this.getData = this.getData.bind(this);
        this.getCategory = this.getCategory.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname;
        if (/^\/productSpec\/add\/\d+$/.test(path)) { //当下一个路由是详情页时，将useStore的值设为true
            specActions.useStoreChange(true);
            specActions.paramChange(this.state.searchObj);
        } else {
            specActions.useStoreChange(false);
            specActions.paramChange({});
        }
    }

    componentWillMount() {
        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                searchObj: data.storeData,
            });
        }
    }

    componentDidMount() {
        this.getData();
        this.getCategory();
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    //获取分类树
    getCategory() {
        treeList2('').then(result => {
            if (result.status) {
                for (var i = 0; i < result.data.length; i++) {
                    result.data[i].value = result.data[i].code;
                    for (var j = 0; j < result.data[i]['children'].length; j++) {
                        result.data[i]['children'][j].value = result.data[i]['children'][j].code;
                        for (var z = 0; z < result.data[i]['children'][j]['children'].length; z++) {
                            result.data[i]['children'][j]['children'][z].value = result.data[i]['children'][j]['children'][z].categoryId;
                            delete result.data[i]['children'][j]['children'][z].children;
                        }
                    }
                }
                this.setState({
                    tree: result.data,
                });
            } else {
                openNotice('warning', result.message);
            }
        });
    }

    //页面跳转
    goView(url) {
        hashHistory.push(url);
    }

    getData() {
        var obj = this.state.searchObj;
        specList(obj).then(result => {
            if (result.status) {
                // for (var i = 0; i < result.data.length; i++) {
                // 	var specValueList = result.data[i].specValueList;
                // 	result.data[i].specvalue = '';
                // 	for (var j = 0; j < specValueList.length; j++) {
                // 		result.data[i].specvalue += specValueList[j].specValue + ' ; ';
                // 	}
                // }
                this.setState({
                    rows: result.data,
                    total: result.total,
                });
            } else {
                message.error(result.message);
            }
        });
    }

    visibleChange() {
        this.setState({filterBoxVisible: !this.state.filterBoxVisible});
    }

    advanceReset() {
        const self = this;
        this.setState({
            filterBoxVisible: !this.state.filterBoxVisible,
            searchObj: {
                ...this.state.searchObj,
                propertyName: '', // 规格
                categoryId: '', // 分类id
                propertyCategoryCode: '', // 本体/附件
                activeFlag: '', // 是否有效（1-有效；0-无效）
                p: 1,
            },
        }, () => {
            self.getData();
        });
    };

    advanceSubmit(form) {
        var submitObj = this.state.searchObj;
        submitObj.p = 1;
        if (submitObj.categoryId.length > 0) {
            submitObj.categoryId = parseInt(submitObj.categoryId[2], 0);
        }
        ;
        /*//有效性选择
         submitObj.active = submitObj.active|| null;*/
        const self = this;
        this.setState({
            filterBoxVisible: !this.state.filterBoxVisible,
            searchObj: submitObj,
        }, function () {
            self.getData();
        });
    }

    setFilterParam(name, value) {
        this.setState({searchObj: {...this.state.searchObj, [name]: value}});
    }

    pageChange(page, pageSize) {
        const self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            self.getData();
        });
    }

    operationHandle(id, act) {
        // 编辑
        if (act === 'edit') {
            this.goView(`/productSpec/add/${id}`);
        }
        // 删除
        if (act === 'delete') {
            confirm({
                title: '确定要删除规格吗?',
                onOk: () => {
                    specDelete({id: id}).then(result => {
                        if (result.status) {
                            message.success(result.message);
                            this.getData();
                        } else {
                            message.error(result.message);
                        }
                    });
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
        }
    }

    sync() {
        productAync().then(res => {
            if (res && res.code == 200) {
                openNotice('success', '同步成功,请等待5分钟', '');
            } else {
                openNotice('error', '同步失败', (res && res.message) ? res.message : '');
            }
        });
    }

    CascaderFilter = (inputValue, path) => {
        return (path.some(option => (option.label).toLowerCase().indexOf(inputValue.toLowerCase()) > -1));
    };


    /*下载模板*/
    downloadChange = () => {
        window.open(`${config.server}/file/productSpec.xlsx`)
    }

    render() {
        const {opts, filterBoxVisible, rows, total, searchObj} = this.state;
        const filterBoxProps = {
            showFlag: filterBoxVisible,
            advance: {
                fileds: [
                    {
                        name: 'propertyName',
                        label: '规格名称',
                        defaultValue: searchObj.propertyName,
                        text: '请输入规格名称',
                        type: 'default',
                    },
                    {
                        name: 'categoryId',
                        label: '产品分类',
                        text: '选择产品类别',
                        type: 'cascader',
                        showSearch: {filter: this.CascaderFilter},
                        defaultValue: searchObj.categoryId,
                        options: this.state.tree,
                        changeOnSelect: false,
                        dropdownStyle: {height: '200px', overflow: 'auto'}
                    }, {
                        name: 'propertyCategoryCode',
                        label: '适用对象',
                        defaultValue: searchObj.propertyCategoryCode || '',
                        options: [
                            {value: '本体', text: '本体'},
                            {value: '附件', text: '附件'},
                        ],
                        type: 'select',
                    }, {
                        name: 'activeFlag',
                        label: '有效性',
                        defaultValue: searchObj.activeFlag || '',
                        options: [
                            {value: '1', text: '有效'},
                            {value: '0', text: '无效'},
                        ],
                        type: 'select',
                    },
                ],
                handle: this.advanceSubmit,
                reset: this.advanceReset,
                fieldHandle: this.setFilterParam,
            },
        };
        const tableViewProps = {
            loading: false,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total,
                current: this.state.searchObj.p,//当前页码
                pageSize: this.state.searchObj.s,//当前分页数
                onChange: this.pageChange,
            },
            columns: [
                {
                    title: '产品分类',
                    dataIndex: 'categoryName',
                    render: text => <span>{text}</span>,
                }, {
                    title: '规格名称',
                    dataIndex: 'propertyName',
                }, {
                    title: '从属规格',
                    dataIndex: 'belongSpecName',
                }, {
                    title: '有效性',
                    dataIndex: 'activeText',
                }, {
                    title: '规格值',
                    dataIndex: 'specValueStr',
                }, {
                    title: '操作',
                    dataIndex: 'id',
                    render: (text, record, index) => <span>
					<a onClick={() => this.operationHandle(record.id, 'edit')}>编辑</a>
                        &emsp;&emsp;&emsp;&emsp;
                        <a onClick={() => this.operationHandle(record.id, 'delete')}>删除</a>
				</span>,
                },
            ],
            rows,
        };
        let uploadParam = toImportExcel(8, () => {
            this.getData();
        });
        return (
            <div className='dms-body'>
                <div>
                    <DmsTab options={opts} defaultKey={0} onChange={this.changeHandle}>
                        <Upload {...uploadParam}>
                            <Button>
                                <Icon type="upload"/>导入
                            </Button>
                        </Upload>
                        <Button icon="download" onClick={this.downloadChange}>下载模板</Button>
                        <Button icon="plus" onClick={() => this.goView('/productSpec/add/0')}>新增</Button>
                        <Button icon="reload" onClick={this.sync.bind(this)}>同步</Button>
                        <Button icon="filter" onClick={this.visibleChange}>筛选</Button>
                        <FilterBox  {...filterBoxProps} />
                    </DmsTab>
                </div>

                <div className="dms-table-box">
                    <TableView {...tableViewProps} />
                </div>
            </div>
        );
    }
};
export default withRouter(ProductSpecList);



// WEBPACK FOOTER //
// ./src/routes/productSpec/list.js